<template>
    <section class="back container-fluid flex-grow-1 bg-dark z-1 position-relative">
        <div class="about-section d-flex flex-column sticky-lg-top">
            <div class="row g-0 z-1">
                <div class="col-12 px-4 d-flex align-items-center justify-content-center justify-content-md-start justify-content-lg-start">
                    <h1 class="display-1 fs-2 fw-bold p-3 bg-white rounded-2 text-dark ms-0 ms-md-5 ms-lg-5 my-0">About</h1>
                </div>
            </div>
            <div class="row g-0 px-sm-0 px-md-5 px-lg-5 flex-fill">
				<AboutFrame />
				<div class="col-12 col-lg-8 col-xl-4 text-white d-flex flex-column justify-content-evenly px-2 px-md-5 px-lg-5 py-5">
                    <div class="text-start">
                        <h5 class="fs-3">A little about me</h5>
                        <p>I am <b>{{ age }}</b> years old, born in <b>30th April 2002</b>. I am training a pattern ready to code and discover the
                            world of development. All ideas start simple, they say. They DO! I figured, and that's where I
                            found my passion to discover the 'magic' behind computers.
						</p>
                    </div>
                    <div class="text-start">
                        <h5 class="fs-3">Quote</h5>
                        <div>
                            <i class='bi bi-quote'></i>
                            <small>The master has failed more times than the beginner has even tried. When you procrastinate
                                you become a slave to yesterday. Failing to plan, is like planning to fail.</small><br>
							<small class="text-warning">by Stephen McCranie.</small>
                        </div>
                    </div>
                </div>
				<div class="col-12 col-lg-4 col-xl-4 pt-5 pb-5 pb-lg-0 d-flex flex-column align-items-center">
					<div class="px-2 w-100">
						<div class="p-3 my-auto bg-white rounded-1">
							<h3 class="text-dark m-0 fw-bold">Interests & Hobbies</h3>
						</div>
					</div>
					<div class="px-2 py-2 w-100 overflow-hidden" style="display: grid;grid-template-columns: calc(50% - .5rem / 2) calc(50% - .5rem / 2);grid-template-rows: auto auto;grid-gap:.5rem;">
						<div class="hobby d-flex">
							<div class="bg-white flex-fill rounded-1 shadow position-relative">
								<div class="w-100 h-100 d-flex flex-column justify-content-evenly justify-content-lg-evenly align-items-center py-1">
									<small class="d-none d-md-block d-lg-block fw-medium fs-7 text-dark-subtle w-100">Game Development</small>
									<div class="hobby p-4 p-sm-4 p-md-4 p-lg-4 p-xl-5 position-relative" style="background-image: url(https://firebasestorage.googleapis.com/v0/b/rezaar-s-portfolio.appspot.com/o/Images%2Fgame-controller.png?alt=media&token=976caf2d-5ebf-456e-b093-01f55d4c6eb4);"></div>
									<!-- <div class="hobby p-4 p-sm-4 p-md-4 p-lg-4 p-xl-5 position-relative" > style="background-image: url(https://i.ibb.co/h8JcQ9z/game-controller.png);" -->
										<!-- <Loader :invert="true"/> -->
									<!-- </div> -->
									<small class="d-none d-lg-block fw-medium fs-7 text-dark-subtle w-100">Unity 3D Engine</small>
								</div>
							</div>
						</div>
						<div class="hobby d-flex">
							<div class="bg-white flex-fill rounded shadow position-relative">
								<div class="w-100 h-100 d-flex flex-column justify-content-evenly align-items-center py-1">
									<small class="d-none d-lg-block fw-medium fs-7 text-dark-subtle w-100">Scripting Exploits</small>
									<div class="hobby p-4 p-sm-4 p-md-4 p-lg-4 p-xl-5 position-relative" style="background-image: url(https://firebasestorage.googleapis.com/v0/b/rezaar-s-portfolio.appspot.com/o/Images%2Fpython.png?alt=media&token=c1786c26-4ca6-4399-a628-241668f94e98);"></div>
									<small class="d-none d-lg-block fw-medium fs-7 text-dark-subtle w-100">Python3</small>
								</div>
							</div>
						</div>
						<div class="hobby d-flex">
							<div class="bg-white flex-fill rounded shadow position-relative">
								<div class="w-100 h-100 d-flex flex-column justify-content-evenly align-items-center py-1">
									<small class="d-none d-lg-block fw-medium fs-7 text-dark-subtle w-100">Building Tech</small>
									<div class="hobby p-4 p-sm-4 p-md-4 p-lg-4 p-xl-5 position-relative" style="background-image: url(https://firebasestorage.googleapis.com/v0/b/rezaar-s-portfolio.appspot.com/o/Images%2Fmotherboard.png?alt=media&token=7a1967c5-5fda-49a8-ab44-4df62ccefd2d);"></div>
									<small class="d-none d-lg-block fw-medium fs-7 text-dark-subtle w-100">MicroControllers</small>
								</div>
							</div>
						</div>
						<div class="hobby d-flex">
							<div class="bg-white flex-fill rounded shadow position-relative">
								<div class="w-100 h-100 d-flex flex-column justify-content-evenly align-items-center py-1">
									<small class="d-none d-lg-block fw-medium fs-7 text-dark-subtle w-100">Cyber Security</small>
									<div class="hobby p-4 p-sm-4 p-md-4 p-lg-4 p-xl-5 position-relative" style="background-image: url(https://firebasestorage.googleapis.com/v0/b/rezaar-s-portfolio.appspot.com/o/Images%2Fhackthebox-svgrepo-com.png?alt=media&token=9880a7b8-b0ab-4d6d-a2cf-bdfbe2bc4bdf);"></div>
									<small class="d-none d-lg-block fw-medium fs-7 text-dark-subtle w-100">HTB Academy</small>
								</div>
							</div>
						</div>
					</div>
				</div>
				
            </div>
        </div>
    </section>
</template>
<script>
import AboutFrame from '@/components/AboutFrame.vue';
import Loader from '@/components/Loader.vue';

export default {
	data(){
		return {
			age: 22
		}
	},
	components: {
		AboutFrame,
		Loader
	},
	mounted(){
		this.age = new Date().getFullYear() - new Date('2002-04-30').getFullYear();
	},
	methods: {
		async getImage(imageUrl){
			let resp = await fetch(imageUrl);
			let data = await resp.blob();

			return URL.createObjectUrl(data);
		}
	}
}
</script>
<style scoped>
.back {
    height: 100vh;
}
.about-section {
	height: 100vh;
}
.hobby {
	background-position: center;
	background-size: cover;
	aspect-ratio: 1;
}

@media screen and (max-width: 576px) {
	.back {
		min-height: auto;
		height: auto;
	}
    .about-section {
        height: auto;
    }
}
</style>